class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
    document.dispatchEvent(new CustomEvent('cart-drawer:open'));
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
      document.dispatchEvent(new CustomEvent('cart-drawer:rendered'));
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

// ===== CART UPSELL LOGIC (carrusel estilo KoalaCloth / UpCart) =====
(function () {
  'use strict';

  var currentIndex = 0;
  var touchStartX = null;

  function getTrack() {
    return document.querySelector('.cart-upsell-carousel__track');
  }

  function getSlides() {
    return document.querySelectorAll('.cart-upsell-carousel__slide');
  }

  // El track se desplaza con translateX (una tarjeta por vista),
  // en lugar de mostrar/ocultar tarjetas con .active.
  function updateCarousel() {
    var track = getTrack();
    var slides = getSlides();
    if (!track || !slides.length) return;

    if (currentIndex > slides.length - 1) currentIndex = slides.length - 1;
    if (currentIndex < 0) currentIndex = 0;

    track.style.transform = 'translateX(' + (-currentIndex * 100) + '%)';

    var prevBtn = document.querySelector('.cart-upsell-carousel__arrow--prev');
    var nextBtn = document.querySelector('.cart-upsell-carousel__arrow--next');
    if (prevBtn) prevBtn.disabled = currentIndex === 0;
    if (nextBtn) nextBtn.disabled = currentIndex === slides.length - 1;
  }

  function go(delta) {
    var slides = getSlides();
    if (!slides.length) return;
    currentIndex = Math.min(Math.max(currentIndex + delta, 0), slides.length - 1);
    updateCarousel();
  }

  /* ---------- Cambio de variante ---------- */
  function onVariantChange(select) {
    var card = select.closest('.cart-upsell-card');
    if (!card) return;

    var opt = select.options[select.selectedIndex];
    var priceEl = card.querySelector('.cart-upsell-card__price-sale');
    var compareEl = card.querySelector('.cart-upsell-card__price-original');
    var btn = card.querySelector('.cart-upsell-card__btn');

    card.dataset.productId = opt.value;
    // La variante cambió: el estado "agregado" ya no corresponde a este id.
    card.dataset.selected = 'false';
    if (btn) btn.disabled = false;

    if (priceEl && opt.dataset.price) priceEl.textContent = opt.dataset.price;

    if (compareEl) {
      var c = opt.dataset.compare || '';
      if (c) {
        compareEl.textContent = c;
        compareEl.removeAttribute('hidden');
      } else {
        compareEl.setAttribute('hidden', '');
      }
    }
  }

  /* ---------- Refresco del drawer ----------
     Usamos renderContents(), el método que YA tiene tu tema y que usa
     product-form.js al agregar desde una página de producto. Le pedimos
     a Shopify la sección 'cart-drawer' recalculada, así se actualizan la
     barra de envío gratis, la lista de items, los descuentos y el total
     (todo eso lo calcula Liquid en el servidor, no se puede hacer con JS). */
  function drawerSectionIds() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      return drawer.getSectionsToRender().map(function (s) { return s.id; });
    }
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  // Tras re-renderizar, el HTML viene con data-selected="false".
  // Volvemos a marcar los que sí están en el carrito, leyendo el carrito real.
  function markSelectedFromCart() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var ids = (cart.items || []).map(function (i) { return String(i.variant_id); });
        Array.prototype.forEach.call(
          document.querySelectorAll('.cart-upsell-card'),
          function (card) {
            card.dataset.selected = ids.indexOf(String(card.dataset.productId)) !== -1 ? 'true' : 'false';
            var b = card.querySelector('.cart-upsell-card__btn');
            if (b) b.disabled = false;
          }
        );
        updateCarousel();
        return cart;
      })
      .catch(function () {
        Array.prototype.forEach.call(
          document.querySelectorAll('.cart-upsell-card__btn'),
          function (b) { b.disabled = false; }
        );
      });
  }

  /* ---------- Add / Remove ---------- */
  function toggleCartItem(btn) {
    var card = btn.closest('.cart-upsell-card');
    if (!card) return;

    var variantId = card.dataset.productId;
    if (!variantId || btn.disabled) return;

    var isSelected = card.dataset.selected === 'true';
    var url  = isSelected ? '/cart/change.js' : '/cart/add.js';
    var body = isSelected
      ? { id: variantId, quantity: 0 }
      : { items: [{ id: Number(variantId), quantity: 1 }] };

    body.sections = drawerSectionIds();
    body.sections_url = window.location.pathname;

    btn.disabled = true;

    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        var drawer = document.querySelector('cart-drawer');
        var rendered = false;

        // Si algo falla acá, NO puede quedar el botón trabado ni romperse el drawer.
        try {
          if (res && res.sections && drawer && typeof drawer.renderContents === 'function') {
            drawer.renderContents(res);
            rendered = true;
          }
        } catch (e) {
          console.error('[cart upsell] renderContents falló, uso el fallback:', e);
        }

        if (rendered) return markSelectedFromCart();

        // Fallback: comportamiento anterior (la barra no se actualiza, pero nada se rompe)
        card.dataset.selected = isSelected ? 'false' : 'true';
        btn.disabled = false;
        return fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) { updateCartTotals(cart); });
      })
      .catch(function (err) {
        console.error('[cart upsell]', err);
        btn.disabled = false;
      });
  }

  /* ---------- Delegación de eventos ---------- */
  document.addEventListener('click', function (e) {
    if (e.target.closest('.cart-upsell-carousel__arrow--prev')) {
      e.preventDefault();
      go(-1);
      return;
    }
    if (e.target.closest('.cart-upsell-carousel__arrow--next')) {
      e.preventDefault();
      go(1);
      return;
    }

    var btn = e.target.closest('.cart-upsell-card__btn');
    if (btn) {
      e.preventDefault();
      toggleCartItem(btn);
    }
  });

  document.addEventListener('change', function (e) {
    var select = e.target.closest('.cart-upsell-card__variants');
    if (select) onVariantChange(select);
  });

  /* ---------- Swipe en mobile ---------- */
  document.addEventListener('touchstart', function (e) {
    if (!e.target.closest('.cart-upsell-carousel__track-wrapper')) return;
    touchStartX = e.touches[0].clientX;
  }, { passive: true });

  document.addEventListener('touchend', function (e) {
    if (touchStartX === null) return;
    if (!e.target.closest('.cart-upsell-carousel__track-wrapper')) { touchStartX = null; return; }
    var dx = e.changedTouches[0].clientX - touchStartX;
    if (Math.abs(dx) > 40) go(dx < 0 ? 1 : -1);
    touchStartX = null;
  }, { passive: true });

  /* ---------- Init / re-init ---------- */
  function init() {
    currentIndex = 0;
    updateCarousel();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('cart-drawer:open', init);
  document.addEventListener('cart-drawer:rendered', init);
  document.addEventListener('shopify:section:load', init);
})();

function updateCartTotals(cart) {
  document.querySelectorAll('[data-cart-item-count]').forEach(function(el) {
    el.textContent = cart.item_count;
  });
  var bubble = document.querySelector('.cart-count-bubble span');
  if (bubble) bubble.textContent = cart.item_count;
  var totalEl = document.querySelector('.totals__total-value');
  if (totalEl && cart.total_price !== undefined) {
    totalEl.textContent = '$' + (cart.total_price / 100).toLocaleString('es-AR', {
      minimumFractionDigits: 2, maximumFractionDigits: 2
    }) + ' ARS';
  }
}